import { Link } from 'react-router-dom';

export default function BrandHeader() {
  return (
    <header className="bg-navy text-white">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/ut-logo.png"
            alt="Utility Trailer of California"
            className="h-8 w-auto bg-white rounded-sm p-1"
          />
          <img
            src="/paccoast-logo.png"
            alt="Pac Coast Trailers"
            className="h-8 w-auto bg-white rounded-sm p-1 shrink-0"
          />
          <div className="bg-crimson w-1.5 h-7 rounded-sm" aria-hidden />
          <span className="font-bold tracking-tight text-lg leading-none">
            UTSales
          </span>
        </Link>
        <span className="hidden sm:block text-xs uppercase tracking-[0.18em] text-navy-100/80">
          Utility Trailer of California · Pac Coast Trailers
        </span>
      </div>
    </header>
  );
}
